import { capitalize } from 'Data/format.js'

export function getOrder(title, status) {
  return `${title}: ${status
    .split('_')
    .map(el => capitalize(el))
    .join(' ')}`
}
